import { useUser } from "@hooks/useUser";
import styles from "./InviteAccountantMessage.module.scss";

export const InviteAccountantMessage = () => {
    const user = useUser();
    return (
        <div>
            <div className="mb-2">
                Hey {user?.firstName ?? ""}, invite your accountant to Kick to:
            </div>
            <ul className={styles.unorderedList}>
                <li>Access your real-time books</li>
                <li>Reduce back and forth</li>
                <li>Simplify tax prep</li>
            </ul>
        </div>
    );
};
